import React from 'react';

export const Column = ({ style, children, ...props }) => (
  <div style={{ display: 'flex', flexDirection: 'column', ...style }} {...props}> {children}</div>
);
